module.exports = __webpack_public_path__ + "img/subheader-sp.6e6cc2ec.jpg";